var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useOkapiKy } from '@folio/stripes/core';
import { useCallback } from 'react';
export function useQueryBuilderCommonSources(entityTypeId) {
    var ky = useOkapiKy();
    return {
        entityTypeDataSource: useCallback(function () { return (entityTypeId ? ky.get("entity-types/".concat(entityTypeId)).json() : undefined); }, [ky, entityTypeId]),
        testQueryDataSource: useCallback(function (_a) {
            var fqlQuery = _a.fqlQuery;
            return ky
                .post('query', {
                json: {
                    entityTypeId: entityTypeId,
                    fqlQuery: JSON.stringify(fqlQuery),
                },
            })
                .json();
        }, [ky, entityTypeId]),
        queryDetailsDataSource: useCallback(function (_a) {
            var queryId = _a.queryId, includeContent = _a.includeContent, offset = _a.offset, limit = _a.limit;
            return ky
                .get("query/".concat(queryId), {
                searchParams: {
                    includeResults: includeContent,
                    offset: offset,
                    limit: limit,
                },
            })
                .json();
        }, [ky]),
        getParamsSource: useCallback(function (p) {
            return ky
                .get("entity-types/".concat(p.entityTypeId, "/columns/").concat(p.columnName, "/values"), {
                searchParams: {
                    search: p.searchValue,
                },
            })
                .json();
        }, [ky]),
    };
}
export function useQueryBuilderResultViewerSources(entityTypeId, listId, visibleColumns) {
    var ky = useOkapiKy();
    return __assign(__assign({}, useQueryBuilderCommonSources(entityTypeId)), { contentDataSource: useCallback(function (_a) {
            var limit = _a.limit, offset = _a.offset;
            return ky
                .get("lists/".concat(listId, "/contents?offset=").concat(offset, "&size=").concat(limit, "&fields=").concat(visibleColumns === null || visibleColumns === void 0 ? void 0 : visibleColumns.join(',')))
                .json();
        }, [ky, listId, visibleColumns]) });
}
